import { ErrorCode } from '@/lib/errors/codes';
import { getErrorCode } from '@/lib/errors/get-error';

// Onglet Abonnement = destination unique du paywall. Toute opération (query ou
// mutation) qui renvoie SUBSCRIPTION_INACTIVE route l'utilisateur ici, où il
// choisit un forfait — sauf l'écran Abonnement lui-même, qui EST la destination
// et rend le sélecteur en place (garde de pathname ci-dessous).
const PAYWALL_PATH = '/settings/subscription';

export function paywallRedirectTarget(error: unknown): string | null {
  return getErrorCode(error) === ErrorCode.SUBSCRIPTION_INACTIVE
    ? PAYWALL_PATH
    : null;
}

// Redirige vers le paywall si l'erreur est SUBSCRIPTION_INACTIVE et qu'on n'y
// est pas déjà (évite une boucle de rechargement). Retourne true si une
// redirection a été déclenchée.
export function redirectToPaywallIfInactive(error: unknown): boolean {
  const target = paywallRedirectTarget(error);
  if (!target) return false;
  if (typeof window === 'undefined') return false;
  if (window.location.pathname === target) return false;
  window.location.assign(target);
  return true;
}
